import React, { useContext } from "react";
import { 
  AppBar, 
  Toolbar, 
  Button, 
  Tooltip, 
  FormControl, 
  Select, 
  MenuItem, 
  InputLabel,
  Box
} from "@mui/material";
import "../../assets/css/menu.css";
import { logOut } from "../../helpers/authValidation";
import AuthContext from "../../helpers/AuthContext";
import { useCompany } from "../../helpers/CompanyContext";
import GroupRemoveIcon from "@mui/icons-material/GroupRemove";
import { useNavigate } from "react-router-dom";

const Topbar = () => {
  const { logoutUser, user } = useContext(AuthContext);
  const { selectedCompany, changeCompany, companies, isAdmin } = useCompany();
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutUser();
    navigate("/login");
  };

  return (
    <AppBar position="static" className="top-bar-container">
      <Toolbar className="d-flex justify-content-end top-bar">
        {/* Company Selector - Only visible for Admin */}
        {isAdmin && (
       <Box sx={{ mr: 3 }}>
  <FormControl 
    variant="outlined" 
    size="small" 
    sx={{ 
      minWidth: 250, 
      backgroundColor: 'white', 
      borderRadius: '4px',
      '& .MuiInputLabel-root': {
        backgroundColor: 'white',
        paddingLeft: '8px',
        paddingRight: '8px',
        top: '2px',  // Move label down slightly
      },
      '& .MuiInputLabel-shrink': {
        top: 0,  // Keep it in normal position when shrunk
      }
    }}
  >
    <InputLabel id="company-select-label">Viewing Company</InputLabel>
    <Select
      labelId="company-select-label"
      value={selectedCompany}
      onChange={(e) => changeCompany(e.target.value)}
      label="Viewing Company"
    >
      {companies.map((company) => (
        <MenuItem key={company.id} value={company.id}>
          {company.name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Box>
        )}

        <Button color="inherit" onClick={handleLogout}>
          <Tooltip title="Logout">
            <GroupRemoveIcon
              color="#fff"
              className="ms-2"
              style={{ fontSize: 30 }}
            />
          </Tooltip>
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;